export const FarmaClassLogo = ({ variant = "color", className = "h-10", testId = "farmaclass-logo" }) => {
  const src = variant === "white" ? "/farmaclass-logo-white.png" : variant === "icon" ? "/farmaclass-icon.png" : "/farmaclass-logo.png";
  return <img src={src} alt="FarmaClass · EFG · Marca · Genérico" className={`${className} w-auto object-contain`} data-testid={testId} />;
};
